import { Navigate, Outlet } from "react-router-dom";
import { useOwnerAuth } from "./OwnerAuthContext";
import { Loader2 } from "lucide-react";

export default function OwnerProtectedRoute() {
  const { owner } = useOwnerAuth();
  if (owner === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#040b1d]">
        <Loader2 className="h-6 w-6 animate-spin text-[#10b7c0]" />
      </div>
    );
  }
  if (!owner) return <Navigate to="/owner/login" replace />;
  return <Outlet />;
}
